import React from 'react';
import { Link } from 'react-router-dom';
import './Products.css';

const products = [
  {
    icon: 'fa-graduation-cap',
    name: 'aivionGrade',
    subtitle: 'AI-Powered Exam Assessment',
    description:
      'Automates marking and feedback for handwritten and digital answer sheets with consistent evaluation and detailed analytics.',
    link: 'https://aiviongrade.aivion.ai/'
  },
  {
    icon: 'fa-user-tie',
    name: 'aivionReach',
    subtitle: 'AI-Supported Employment Platform',
    description:
      'Helps job seekers explore career goals, build skills, prepare tailored applications, connect with employers, and track progress.',
    link: '/aivionreach'
  },
  {
    icon: 'fa-chart-pie',
    name: 'aivionScore',
    subtitle: 'AI-Based Credit Review',
    description:
      'Automated financial analysis, risk scoring, and portfolio dashboards for faster, more informed credit decisions.',
    link: '/aivionscore'
  },
  {
    icon: 'fa-chart-line',
    name: 'aivionSales',
    subtitle: 'AI-Based Sales & CRM',
    description:
      'Predictive analytics and automation to enhance lead qualification, pipeline visibility, and forecasting accuracy.',
    link: '/aivionsales'
  },
  {
    icon: 'fa-user-tie',
    name: 'DigitalDeputee',
    subtitle: 'Digital Employees Platform',
    description:
      'Design, deploy, and govern AI agents that orchestrate workflows within enterprise governance and security frameworks.',
    link: '/digitaldeputee'
  }
];

const ProductCard = ({ product }) => {
  const inner = (
    <div className="product-card">
      <svg className="electric-svg" xmlns="http://www.w3.org/2000/svg">
        <rect
          className="electric-rect"
          x="4"
          y="4"
          width="calc(100% - 8px)"
          height="calc(100% - 8px)"
          rx="18"
          ry="18"
          fill="none"
          stroke="#22c55e"
          strokeWidth="2"
          strokeDasharray="6 5"
          strokeLinecap="round"
        />
      </svg>
      <div className="product-icon">
        <i className={"fas " + product.icon}></i>
      </div>
      <h3>{product.name}</h3>
      <h4>{product.subtitle}</h4>
      <p>{product.description}</p>
    </div>
  );

  if (product.link) {
    const isExternal = product.link.startsWith('http');
    if (isExternal) {
      return React.createElement(
        "a",
        {
          href: product.link,
          target: "_blank",
          rel: "noopener noreferrer",
          style: { textDecoration: "none", color: "inherit" }
        },
        inner
      );
    }
    return React.createElement(
      Link,
      {
        to: product.link,
        style: { textDecoration: "none", color: "inherit" }
      },
      inner
    );
  }

  return inner;
};

const Products = () => {
  return (
    <section id="products" className="products-section">

      <svg width="0" height="0" style={{ position: 'absolute', overflow: 'hidden' }}>
        <defs>
          <filter id="electric-distortion" x="-30%" y="-30%" width="160%" height="160%">
            <feTurbulence
              type="turbulence"
              baseFrequency="0.035 0.065"
              numOctaves="2"
              seed="8"
              result="noise"
            >
              <animate
                attributeName="baseFrequency"
                values="0.025 0.055;0.045 0.08;0.03 0.06;0.05 0.09;0.025 0.055"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="seed"
                values="8;3;11;5;8"
                dur="1.2s"
                repeatCount="indefinite"
              />
            </feTurbulence>
            <feDisplacementMap
              in="SourceGraphic"
              in2="noise"
              scale="15"
              xChannelSelector="R"
              yChannelSelector="G"
              result="displaced"
            />
          </filter>
        </defs>
      </svg>

      <div className="container">
        <div className="section-header">
          <h2>Our Products</h2>
          <p>AI-powered platforms solving real business challenges across industries.</p>
        </div>

        <div className="products-grid">
          {products.map((product, index) => (
            <ProductCard key={index} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
